import { combineReducers } from 'redux';

import { byId } from './byId';
import { isFetching } from './isFetching';

export const reducer = combineReducers({
  byId,
  isFetching
});
